import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DealerRequestModel, DealerViewModel } from '../../../business-entities/dealer-view-model';
import { MechanicList } from '../../../business-entities/mechanicList-model';
import { MechanicService } from '../../../business-services/mechanic.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { MechanicTimeStampReportModel, TimeStampReportModel, TimeStampRequestModel, TimeStampResponseModel } from '../../../business-entities/time-stamp-report-model';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';

@Component({
  selector: 'app-workorder-time-stamp-report',
  templateUrl: './workorder-time-stamp-report.component.html',
})

export class WorkorderTimeStampReportComponent implements OnInit {
  dealerList: DealerViewModel[] = [];
  dealers: DealerViewModel[] = [];
  dealerId: string = '';
  isDealerRequired: boolean = false;
  isMechanicRequired: boolean = false;
  isMechanicSelected: boolean;
  selectedMechanic: number;
  mechanicList: MechanicList[] = [];
  dealerRequestModel: DealerRequestModel = {
    keyLocation: false,
    onlinePayment: false,
    isAdvanceSearch: false,
    statusId: 0,
    isAllDealer: false,
    isForList: false
  };
  mechanicId: any;
  isSearched: boolean = false;
  dealerName: string;
  timeStampList: MechanicTimeStampReportModel[] = [];
  totalCount: number = 0;
  requestModel: TimeStampRequestModel = {
    dealerId: '',
    mechanicId: 0,
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    dateRange: '',
    serachTerm: '',
    workOrder: '',
    IsDocument: false
  };
  scrollDistance = 1;
  throttle = 100;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({}, {
    containerClass: 'theme-dark-blue',
    displayMonths: 1,
    showWeekNumbers: false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  stampInDate: any[];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  modal: any;
  entityId: number;
  timeStampDetails: TimeStampResponseModel[] = [];
  timeStampReport: TimeStampReportModel[] = [];
  language: any;
  dateTimeFormat: string = 'dd.MM.yyyy, HH:mm:ss';

  IsDocument: boolean = false;
  exportTimeStampList: MechanicTimeStampReportModel[] = [];

  constructor(
    private userService: UserDataService,
    public mechanicService: MechanicService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private translate: TranslateService,
    private toastr: ToastrService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
    private excelService: ExcelService
  ) { }

  ngOnInit(): void {
    this.dealerId = this.userService.currentUserValue.defaultDealerId ?? '';
    this.setDefaultCurrentMonth();
    this.GetAll();
  }

  private setDefaultCurrentMonth(): void {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    this.stampInDate = [];
    this.stampInDate.push(firstDayOfMonth);
    this.stampInDate.push(lastDayOfMonth);
  }

  GetAll() {
    this.mechanicService.GetDealerList(this.dealerRequestModel).then(data => {
      this.dealerList = data.responseObject;
      for (let value of this.dealerList) {
        this.dealers.push(value);
      }
      if (this.dealerList.length === 1) {
        this.dealerId = this.dealers[0].dealerId;
        this.GetMechanicList(this.dealerId);
      }
      else if(this.dealerId != ''){
        this.GetMechanicList(this.dealerId);
      }
    })
  }

  onDealerChange(value) {
    this.isDealerRequired = !value;
    this.mechanicId = null;
    this.selectedDealer();
  }

  selectedDealer() {
    this.isMechanicSelected = false;
    this.selectedMechanic = 0;
    this.isMechanicRequired = false;
    this.GetMechanicList(this.dealerId);
  }

  async GetMechanicList(id: string) {
    this.spinner.show();
    await this.mechanicService.GetMechanicList(id, Enums.StatusCode.Active).then(response => {
      if (response.responseCode == Constant.SuccessResponseCode) {
        this.mechanicList = response.responseObject;
      }
      this.spinner.hide();
    });
  }

  onSelectMechanic(e: any) {
    this.isMechanicRequired = !e || e <= 0;
    this.mechanicId = e;
    if (this.mechanicId && this.mechanicId > 0) {
      this.isMechanicSelected = true;
      this.isSearched = true;
      this.dealerName = this.dealers.filter(x => x.dealerId === this.dealerId)[0]?.name;
      this.timeStampList = [];
      this.requestModel.startRecordNumber = 0;
    } else {
      this.isMechanicSelected = false;
      this.isSearched = false;
    }
  }

  private validateForm(): boolean {
    let isValid = true;
    this.isDealerRequired = !this.dealerId;
    if (this.isDealerRequired) {
      isValid = false;
      this.toastr.error(this.translate.instant('lblRequiredDealer'));
    }
    this.isMechanicRequired = !this.mechanicId || this.mechanicId <= 0;
    if (this.isMechanicRequired) {
      isValid = false;
      this.toastr.error(this.translate.instant('lblRequiredMechanic'));
    }
    return isValid;
  }

  async getTimeStampReport() {
    if (!this.validateForm()) {
      return;
    }

    this.spinner.show();
    this.requestModel.dealerId = this.dealerId;
    this.requestModel.mechanicId = this.mechanicId;
    this.requestModel.IsDocument = false;
    this.totalCount = 0;
    await this.mechanicService.GetMechanicWorkTimeStampList(this.requestModel)
      .then(result => {
        if (result.responseCode === Constant.SuccessResponseCode) {
          this.timeStampList = result.responseObject;
          if (this.timeStampList?.length) {
            this.totalCount = this.timeStampList[0].totalRecords;
            this.timeStampList.forEach(element => {
              element.startTime = element.startTime ? new Date(element.startTime + 'Z') : null;
              element.endTime = element.endTime ? new Date(element.endTime + 'Z') : null;
            });
          }
        } else {
          this.timeStampList = [];
          this.totalCount = 0;
        }
        this.spinner.hide();
      })
  }

  onScrollDown() {
    if (this.totalCount > this.timeStampList?.length) {
      this.requestModel.startRecordNumber = this.timeStampList.length
      this.getTimeStampReport();
    }
  }

  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.requestModel.sortColumn = column;
    this.requestModel.sortDirection = direction;
    this.requestModel.startRecordNumber = 0;
    this.timeStampList = [];
    this.getTimeStampReport();
  }

  onSearchReport() {
    if (!this.validateForm()) {
      return;
    }
    let stampInDateFormatted = this.getFormattedDate(this.stampInDate);
    this.requestModel.dateRange = stampInDateFormatted;
    this.requestModel.startRecordNumber = 0;
    this.timeStampList = [];
    this.getTimeStampReport();
  }

  onReset() {
    this.dealerId = null;
    this.mechanicId = null;
    this.selectedMechanic = 0;
    this.isMechanicSelected = false;
    this.isSearched = false;
    this.isDealerRequired = false;
    this.isMechanicRequired = false;
    this.timeStampList = [];
    this.timeStampDetails = [];
    this.timeStampReport = [];
    this.totalCount = 0;
    this.exportTimeStampList = [];
    this.IsDocument = false;
    this.setDefaultCurrentMonth();
    this.mechanicList = [];
    this.cdr.detectChanges();
  }

  refresh() {
    this.onSearchReport();
  }

  // Excel Export Functionality 
  public async exportAsXLSX(): Promise<void> {
    if (await this.validateExport()) {
      const excelData = this.mapExportData();
      this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblTimeStampReport')}`);
    }
  }

  // PDF Export Functionality 
  public async exportAsPDF(): Promise<void> {
    if (await this.validateExport()) {
      const pdfData = this.mapExportData();
      const doc = new jsPDF('landscape');
      autoTable(doc, {
        head: [this.getExportHeaders()],
        body: pdfData.map(row => Object.values(row)),
        margin: { top: 3, left: 3, right: 3, bottom: 3 },
        styles: { fontSize: 8 },
        columnStyles: this.getColumnStyles()
      });
      doc.save(`${this.translate.instant('lblTimeStampReport')}.pdf`);
    }
  }

  private async validateExport(): Promise<boolean> {
    if (!this.dealerId) {
      this.isDealerRequired = true;
      return false;
    }
    if (!this.mechanicId || this.mechanicId <= 0) {
      this.isMechanicRequired = true;
      return false;
    }
    if (this.exportTimeStampList.length === 0) {
      await this.loadExportTimeStampReport();
    }
    if (this.exportTimeStampList.length === 0) {
      this.toastr.error(this.translate.instant('lblDataNotAvailable'));
      return false;
    }
    return true;
  }

  private async loadExportTimeStampReport(): Promise<void> {
    this.exportTimeStampList = [];
    const exportRequestModel = { ...this.requestModel };
    exportRequestModel.startRecordNumber = 0;
    exportRequestModel.pageSize = 1;
    exportRequestModel.IsDocument = true
    this.spinner.show();
    exportRequestModel.dealerId = this.dealerId;
    exportRequestModel.mechanicId = this.mechanicId;
    let stampInDateFormatted = this.getFormattedDate(this.stampInDate);
    exportRequestModel.dateRange = stampInDateFormatted;
    await this.mechanicService.GetMechanicWorkTimeStampList(exportRequestModel)
      .then(result => {
        if (result.responseCode === Constant.SuccessResponseCode) {
          this.exportTimeStampList = result.responseObject;
          this.exportTimeStampList.forEach(element => {
            element.startTime = element.startTime ? new Date(element.startTime + 'Z') : null;
            element.endTime = element.endTime ? new Date(element.endTime + 'Z') : null;
          });
        }
        this.spinner.hide();
      });
  }


  private mapExportData(): any[] {
    const data = this.exportTimeStampList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblMechanicNumber')]: item.employeeNo,
      [this.translate.instant('lblMechanicName')]: item.mechanicName,
      [this.translate.instant('lblWoNo')]: item.orderNo,
      [this.translate.instant('lblJob')]: `${item.demandNo} - ${item.description}`,
      [this.translate.instant('lblPunchDate')]: this.datePipe.transform(item.punchDate, 'shortDate'),
      [this.translate.instant('lblStartTime')]: this.datePipe.transform(item.startTime, 'HH:mm:ss'),
      [this.translate.instant('lblEndTime')]: this.datePipe.transform(item.endTime, 'HH:mm:ss'),
      [this.translate.instant('lblMissedPunch')]: item.missedPunch,
      [this.translate.instant('lblStandardTime')]: item.workTime,
      [this.translate.instant('lblTimeConsumed')]: item.timeUsed
    }));

    // Add totals row if data exists
    if (this.exportTimeStampList.length > 0) {
      const totalsRow = {
        [this.translate.instant('lblNo')]: '',
        [this.translate.instant('lblMechanicNumber')]: '',
        [this.translate.instant('lblMechanicName')]: '',
        [this.translate.instant('lblWoNo')]: '',
        [this.translate.instant('lblJob')]: '',
        [this.translate.instant('lblPunchDate')]: '',
        [this.translate.instant('lblStartTime')]: '',
        [this.translate.instant('lblEndTime')]: `${this.translate.instant('lblTotal')}:`,
        [this.translate.instant('lblMissedPunch')]: '',
        [this.translate.instant('lblStandardTime')]: this.exportTimeStampList[0].totalWorkTimeFormatted,
        [this.translate.instant('lblTimeConsumed')]: this.exportTimeStampList[0].totalTimeUsedFormatted
      };
      data.push(totalsRow);

      // Add efficiency row
      const efficiencyRow = {
        [this.translate.instant('lblNo')]: '',
        [this.translate.instant('lblMechanicNumber')]: '',
        [this.translate.instant('lblMechanicName')]: '',
        [this.translate.instant('lblWoNo')]: '',
        [this.translate.instant('lblJob')]: '',
        [this.translate.instant('lblPunchDate')]: '',
        [this.translate.instant('lblStartTime')]: '',
        [this.translate.instant('lblEndTime')]: `${this.translate.instant('lblEfficiencyTitle')}:`,
        [this.translate.instant('lblMissedPunch')]: '',
        [this.translate.instant('lblStandardTime')]: `${this.exportTimeStampList[0].efficiencyPercent}%`,
        [this.translate.instant('lblTimeConsumed')]: ''
      };
      data.push(efficiencyRow);
    }

    return data;
  }

  private getExportHeaders(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblMechanicNumber'),
      this.translate.instant('lblMechanicName'),
      this.translate.instant('lblWoNo'),
      this.translate.instant('lblJob'),
      this.translate.instant('lblPunchDate'),
      this.translate.instant('lblStartTime'),
      this.translate.instant('lblEndTime'),
      this.translate.instant('lblMissedPunch'),
      this.translate.instant('lblStandardTime'),
      this.translate.instant('lblTimeConsumed')
    ];
  }

  private getColumnStyles(): any {
    return {
      0: { cellWidth: 15 },
      1: { cellWidth: 25 },
      2: { cellWidth: 35 },
      3: { cellWidth: 25 },
      4: { cellWidth: 40 },
      5: { cellWidth: 25 },
      6: { cellWidth: 25 },
      7: { cellWidth: 25 },
      8: { cellWidth: 26 },
      9: { cellWidth: 25 },
      10: { cellWidth: 25 }
    };
  }

  onDateRangeChanged(event) {
    let eventFormatted = this.getFormattedDate(event);
    if (!eventFormatted) {
      this.onDateSelectionCleared();
    }
  }

  onDateSelectionCleared() {
    let warningmsg = this.translate.instant("lblShowingCurrentMonthData");
    this.toaster.warning(warningmsg);
    this.setDefaultCurrentMonth();
    this.cdr.detectChanges();
  }

  getFormattedDate(dateRangeArray: any[]): string {
    let formattedDate: string = "";
    if (dateRangeArray && dateRangeArray.length === 2 && dateRangeArray[0] && dateRangeArray[1]) {
      let beginDate = this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate = this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate = beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }

  getTotalWorkTimeFormatted(): string {
    if (this.timeStampList && this.timeStampList.length > 0) {
      return this.timeStampList[0].totalWorkTimeFormatted || '00:00:00';
    }
    return '00:00:00';
  }

  getTotalTimeUsedFormatted(): string {
    if (this.timeStampList && this.timeStampList.length > 0) {
      return this.timeStampList[0].totalTimeUsedFormatted || '00:00:00';
    }
    return '00:00:00';
  }

  getEfficiencyPercent(): number {
    if (this.timeStampList && this.timeStampList.length > 0) {
      return this.timeStampList[0].efficiencyPercent || 0;
    }
    return 0;
  }
}